export default {
    add: 'add',
    replace: 'replace',
};
